<ngx-loading-bar color="#00FFFF" [includeSpinner]="false"></ngx-loading-bar>
<div
  *ngIf="!initialLoadingDone"
  nz-row
  nzJustify="center"
  style="height: 100vh; font-size: 32px"
>
  <div nz-col nzSpan="6" class="text-center" style="margin: auto">
    <span><i nz-icon nzType="loading" nzTheme="outline"></i></span>
  </div>
</div>
<nz-header nz-col nzAlign="center" class="main-header">
  <div nz-row nzJustify="space-between" nzAlign="middle">
    <div nz-row>
      <img
        src="../../../../assets/images/logos/ethax.svg"
        width="200px"
        style="margin-right: 20px"
      />
      <!-- <div nz-row nzAlign="middle">
        <div
          nz-col
          nzAlign="middle"
          class="trading-assets"
          style="border-right: 1px solid gray"
        >
          <p>BTC/USD:</p>
          <p>
            <b>${{ btc_usd | number : "1.1-1" }}</b>
          </p>
        </div>
        <div
          nz-col
          nzAlign="middle"
          class="trading-assets"
          style="border-right: 1px solid gray"
        >
          <p>ETH/USD:</p>
          <p>
            <b>${{ eth_usd | number : "1.1-1" }}</b>
          </p>
        </div>
        <div nz-col nzAlign="middle" class="trading-assets">
          <p>ETHAX/USD:</p>
          <p>
            <b>${{ ethax_usd | number : "1.1-3" }}</b>
          </p>
        </div>
        <div nz-row>
          <div
            nz-col
            class="trading-balance"
            [ngStyle]="{
              backgroundColor: !account?.enablePaperTrading
                ? '#00FFFF'
                : '#F4FB73'
            }"
          >
            <p>{{ "totalBalance" | translate }}</p>
            <p *ngIf="account?.enablePaperTrading">
              <b>{{ "paperTradingBalance" | translate }} </b>
            </p>
          </div>
          <div
            *ngIf="totalBTCPortfolioValue"
            nz-col
            class="trading-balance"
            [ngStyle]="{
              backgroundColor: !account?.enablePaperTrading
                ? '#00FFFF'
                : '#F4FB73'
            }"
          >
            <p>₿</p>
            <p>
              <b
                >{{
                  maskValues
                    ? (totalBTCPortfolioValue
                      | maskNumber : totalBTCPortfolioValue.toString().length)
                    : (totalBTCPortfolioValue | number : "1.0-1")
                }}
              </b>
            </p>
          </div>
          <div
            *ngIf="totalUSDPortfolioValue"
            nz-col
            class="trading-balance"
            [ngStyle]="{
              backgroundColor: !account?.enablePaperTrading
                ? '#00FFFF'
                : '#F4FB73'
            }"
          >
            <p>$</p>
            <p>
              <b
                >{{
                  maskValues
                    ? (totalUSDPortfolioValue
                      | maskNumber : totalUSDPortfolioValue.toString().length)
                    : (totalUSDPortfolioValue | number : "1.0-2")
                }}
              </b>
            </p>
          </div>

          <button
            nz-button
            nzType="primary"
            (click)="openTopMenu()"
            [disabled]="isFetchData"
            [nzLoading]="isFetchData"
          >
            {{ isFetchData ? "Fetching" : "Refresh" }}
          </button>
        </div>
      </div> -->
    </div>
    <div nz-row class="menuControl">
      <div nz-col  class="balance">
        <button nz-button nz-dropdown [nzDropdownMenu]="menu" style="margin-right: 1rem;">
          Market Price
        </button>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <div nz-row nzAlign="middle">
            <div
              nz-col
              nzAlign="middle"
              class="trading-assets"
              style="border-right: 1px solid gray"
            >
              <p>BTC/USD:</p>
              <p>
                <b>${{ btc_usd | number : "1.1-1" }}</b>
              </p>
            </div>
            <div
              nz-col
              nzAlign="middle"
              class="trading-assets"
              style="border-right: 1px solid gray"
            >
              <p>ETH/USD:</p>
              <p>
                <b>${{ eth_usd | number : "1.1-1" }}</b>
              </p>
            </div>
            <div nz-col nzAlign="middle" class="trading-assets">
              <p>ETHAX/USD:</p>
              <p>
                <b>${{ ethax_usd | number : "1.1-3" }}</b>
              </p>
            </div>
          <button
          nz-button style="margin:0px 5px"
          nzType="primary"
          (click)="openTopMenu()"
          [disabled]="isFetchData"
          [nzLoading]="isFetchData"
        >
        <span nz-icon nzType="redo" nzTheme="outline" *ngIf="!isFetchData" ></span>
        </button>
          </div>
        </nz-dropdown-menu>
      </div>
      <div nz-col class="balance" *ngIf="exchangeAccountList?.length">
        <button nz-button nz-dropdown [nzDropdownMenu]="balanceMenu" style="margin-right: 1rem;">
         Balance
        </button>
        <nz-dropdown-menu #balanceMenu="nzDropdownMenu">
          <div nz-row nzAlign="middle">
            <div
              nz-col
              nzAlign="middle"
              class="trading-assets"
              style="border-right: 1px solid gray"
            >
              <p>{{ "totalBalance" | translate }}</p>
              <p *ngIf="account?.enablePaperTrading">
                <b>{{ "paperTradingBalance" | translate }}</b>
              </p>
            </div>
            <div
              nz-col
              nzAlign="middle"
              class="trading-assets"
              style="border-right: 1px solid gray"
            >
              <p>BTC (₿):</p>
              <p>
                <b>{{
                  maskValues
                    ? (totalBTCPortfolioValue
                      | maskNumber : totalBTCPortfolioValue.toString().length)
                    : (totalBTCPortfolioValue | number : "1.0-1")
                }}</b>
              </p>
            </div>
            <div nz-col nzAlign="middle" class="trading-assets">
              <p>USD ($):</p>
              <p>
                <b>{{
                  maskValues
                    ? (totalUSDPortfolioValue
                      | maskNumber : totalUSDPortfolioValue.toString().length)
                    : (totalUSDPortfolioValue | number : "1.0-2")
                }}</b>
              </p>
            </div>
          <button
          nz-button style="margin:0px 5px"
          nzType="primary"
          (click)="openTopMenu()"
          [disabled]="isFetchData"
          [nzLoading]="isFetchData"
        >
        <span nz-icon nzType="redo" nzTheme="outline" *ngIf="!isFetchData" ></span>
        </button>
          </div>
        </nz-dropdown-menu>

      </div>
      <div class="m-t-1 language-form" style="width: 120px" >
        <nz-form-item style="margin: 0px" >
          <nz-form-control >
            <nz-select 
              [(ngModel)]="language"
              (ngModelChange)="onLanguageChange($event)"
            >
              <nz-option nzValue="ar" nzLabel="Arabic"></nz-option>
              <nz-option nzValue="zh" nzLabel="Chinese"></nz-option>
              <nz-option nzValue="cs" nzLabel="Czech"></nz-option>
              <nz-option nzValue="en" nzLabel="English"></nz-option>
              <nz-option nzValue="et" nzLabel="Estonian"></nz-option>
              <nz-option nzValue="fr" nzLabel="French"></nz-option>
              <nz-option nzValue="de" nzLabel="German"></nz-option>
              <nz-option nzValue="ja" nzLabel="Japanese"></nz-option>
              <nz-option nzValue="ko" nzLabel="Korean"></nz-option>
              <nz-option nzValue="pt" nzLabel="Portuguese"></nz-option>
              <nz-option nzValue="ro" nzLabel="Romanian"></nz-option>
              <nz-option nzValue="ru" nzLabel="Russian"></nz-option>
              <nz-option nzValue="es" nzLabel="Spanish"></nz-option>
              <nz-option nzValue="tr" nzLabel="Turkish"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div
        nz-col
        class="align-self-center m-l-2 ant-col-order-4 order-3 order-xs-2"
      >
        <nz-space nz-col class="justify-end">
          <!-- notification -->
          <div
            *nzSpaceItem
            class="d-flex custom-spacing-notification align-self-center"
          >
           
            <a (click)="toggleMasking()" *ngIf="exchangeAccountList?.length">
              <nz-badge class="header-icons" >
                <i
                  nz-icon
                  nzTheme="outline"
                  [nzType]="maskValues ? 'eye-invisible' : 'eye'"
                ></i>
              </nz-badge>
            </a>
            <!-- <i class="custom-spacing-notification" nz-icon style="color: cyan; margin-top: 15px"
                        [nzType]="maskValues ? 'eye-invisible' : 'eye'" nzTheme="outline" (click)="toggleMasking()"></i> -->
            <a
              nz-dropdown
              [nzDropdownMenu]="notifMenu"
              nzTrigger="click"
              [nzDisabled]="notifications.length == 0"
              (click)="markAllAsRead()"
            >
              <nz-badge class="header-icons"
                nzDot
                [nzShowDot]="unreadNotificationsCount > 0"
              >
                <i
                  nz-tooltip
                  nzTooltipTitle="{{ 'notifications' | translate }}"
                  nzTooltipPlacement="bottom"
                  nz-icon
                  nzType="bell"
                ></i>
              </nz-badge>
            </a>
            <nz-dropdown-menu #notifMenu="nzDropdownMenu">
              <ul nz-menu nzSelectable>
                <li
                  nz-menu-item
                  *ngFor="let item of notifications | slice : 0 : 10"
                  (click)="markAsRead(item)"
                >
                  <span
                    [style.font-weight]="item.read ? 'normal' : 'bold'"
                    [innerHTML]="item.message"
                  ></span>
                  &nbsp;&nbsp;<span>{{ item.createdDate | time_ago }}</span>
                </li>
              </ul>
            </nz-dropdown-menu>
            <a
              nz-dropdown
              [nzDropdownMenu]="profileMenu"
              nzTrigger="click"
              (click)="markAllAsRead()"
              class="d-flex flex-row align-items-center justify-content-center"
            >
              <nz-badge
                class="d-flex flex-row align-items-center justify-content-center profile-icon"
              >
                <img
                  src="../../../../assets/images/icons/User_icon_1.svg"
                  alt="user_icon"
                />
              </nz-badge>
            </a>
            <nz-dropdown-menu #profileMenu="nzDropdownMenu">
              <ul>
                <!-- Settings -->
                <li
                  nz-menu-item
                  [routerLink]="['/', 'user', 'account']"
                  [nzMatchRouter]="true"
                  [nzMatchRouterExact]="true"
                >
                  <div class="d-flex" style="gap: 8px">
                    <span
                      class="icon-menu"
                      style="display: flex; align-items: center"
                    >
                      <img
                        src="../../../../assets/images/icons/setting.svg"
                        width="18px"
                      />
                    </span>
                    <span>{{ "Settings" | translate }}</span>
                  </div>
                </li>
                <!-- Event Logs -->
                <li
                  nz-menu-item
                  [routerLink]="['/', 'reports']"
                  [nzMatchRouter]="true"
                  [nzMatchRouterExact]="true"
                >
                  <div class="d-flex" style="gap: 8px">
                    <span
                      class="icon-menu"
                      style="display: flex; align-items: center"
                    >
                      <img
                        src="../../../../assets/images/icons/clipboard.svg"
                        width="18px"
                      />
                    </span>
                    <span>{{ "Event Logs" | translate }}</span>
                  </div>
                </li>
                <!-- Logout -->
                <li nz-menu-item (click)="logout()">
                  <div class="d-flex" style="gap: 8px">
                    <span
                      class="icon-menu"
                      style="display: flex; align-items: center"
                    >
                      <img
                        src="../../../../assets/images/icons/power-off.svg"
                        width="18px"
                      />
                    </span>
                    <span>{{ "Logout" | translate }}</span>
                  </div>
                </li>
              </ul>
              <!-- </li> -->
            </nz-dropdown-menu>
          </div>
          <!-- end notifications -->
        </nz-space>
      </div>
    </div>
  </div>
</nz-header>

<nz-layout class="outer-layout" *ngIf="initialLoadingDone">
  <nz-sider
    nzCollapsible
    [nzWidth]="'calc(20vw + 1px)'"
    [nzCollapsedWidth]="60"
    [(nzCollapsed)]="isCollapsed"
    (mouseenter)="isCollapsed = false"
    (mouseleave)="isCollapsed = true"
    style="z-index:999"
  >
    <div class="menu-holder">
      <ul
        nz-menu
        nzTheme="dark"
        nzMode="inline"
        [nzInlineCollapsed]="true"
        style="margin-bottom: 100px"
      >
        <!-- Dashboard -->
        <li
          nz-menu-item
          [routerLink]="['/', 'dashboard']"
          *ngIf="exchangeAccountList && exchangeAccountList?.length > 0"
          [nzMatchRouter]="true"
          [nzMatchRouterExact]="true"
          class="single"
        >
          <div>
            <span class="icon-menu">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <g id="Group_62" data-name="Group 62">
                  <g
                    id="Rectangle_2"
                    data-name="Rectangle 2"
                    fill="none"
                    stroke="#fff"
                    stroke-width="1"
                  >
                    <rect width="20" height="20" rx="4" stroke="none" />
                    <rect
                      x="0.5"
                      y="0.5"
                      width="19"
                      height="19"
                      rx="3.5"
                      fill="none"
                    />
                  </g>
                </g>
                <g
                  id="Group_69"
                  data-name="Group 69"
                  transform="translate(4 4)"
                >
                  <rect
                    id="Rectangle_38"
                    data-name="Rectangle 38"
                    width="6"
                    height="7"
                    rx="2"
                    fill="#fff"
                  />
                  <rect
                    id="Rectangle_41"
                    data-name="Rectangle 41"
                    width="5"
                    height="7"
                    rx="2"
                    transform="translate(7 5)"
                    fill="#fff"
                  />
                  <rect
                    id="Rectangle_39"
                    data-name="Rectangle 39"
                    width="6"
                    height="4"
                    rx="2"
                    transform="translate(0 8)"
                    fill="#fff"
                  />
                  <rect
                    id="Rectangle_40"
                    data-name="Rectangle 40"
                    width="5"
                    height="4"
                    rx="2"
                    transform="translate(7)"
                    fill="#fff"
                  />
                </g>
              </svg>
            </span>
            <span>{{ "My Portfolio" | translate }}</span>
          </div>
        </li>
        <li
          nz-menu-item
          [routerLink]="['/', 'subscription']"
          [nzMatchRouter]="true"
          [nzMatchRouterExact]="true"
          class="single"
        >
          <div>
            <span class="icon-menu">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
              >
                <g id="Group_404">
                  <g
                    id="Rectangle_2_hh"
                    fill="none"
                    stroke="#fff"
                    stroke-width="1"
                  >
                    <rect width="20" height="20" rx="4" stroke="none" />
                    <rect
                      x="0.5"
                      y="0.5"
                      width="19"
                      height="19"
                      rx="3.5"
                      fill="none"
                    />
                  </g>
                  <g id="Group_405" transform="translate(4 3)">
                    <path
                      id="Icon_awesome-briefcase"
                      d="M 7.5 9.375 C 7.5 9.582187652587891 7.332187652587891 9.75 7.125 9.75 L 4.875 9.75 C 4.667812347412109 9.75 4.5 9.582187652587891 4.5 9.375 L 4.5 8.25 L 0 8.25 L 0 11.625 C 0 12.22500038146973 0.5250000357627869 12.75 1.125 12.75 L 10.875 12.75 C 11.47500038146973 12.75 12 12.22500038146973 12 11.625 L 12 8.25 L 7.5 8.25 L 7.5 9.375 Z"
                      fill="#fff"
                    />
                    <path
                      id="Icon_awesome-briefcase_hk"
                      d="M 10.875 4.5 L 9 4.5 L 9 3.375 C 9 2.775000095367432 8.475000381469727 2.25 7.875 2.25 L 4.125 2.25 C 3.525000095367432 2.25 3 2.775000095367432 3 3.375 L 3 4.5 L 1.125 4.5 C 0.5250000357627869 4.5 0 5.025000095367432 0 5.625 L 0 7.5 L 12 7.5 L 12 5.625 C 12 5.025000095367432 11.47500038146973 4.5 10.875 4.5 Z M 7.5 4.5 L 4.5 4.5 L 4.5 3.75 L 7.5 3.75 L 7.5 4.5 Z"
                      fill="#fff"
                    />
                  </g>
                </g>
              </svg>
            </span>
            <span>{{ "Subscription" | translate }}</span>
          </div>
        </li>

        <li
          nz-menu-item
          [routerLink]="['/', 'exchange', 'connect']"
          [nzMatchRouter]="true"
          [nzMatchRouterExact]="true"
          class="single"
        >
          <div>
            <span class="icon-menu">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
              >
                <g
                  id="Rectangle_2"
                  data-name="Rectangle 2"
                  fill="none"
                  stroke-width="1"
                >
                  <rect width="20" height="20" rx="4" stroke="none" />
                  <rect
                    x="0.5"
                    y="0.5"
                    width="19"
                    height="19"
                    rx="3.5"
                    fill="none"
                  />
                </g>
                <path
                  id="Icon_awesome-exchange-alt"
                  data-name="Icon awesome-exchange-alt"
                  d="M-.032,7.407V6.894a.77.77,0,0,1,.77-.77H7.862V4.585A.77.77,0,0,1,9.176,4.04l2.566,2.566a.77.77,0,0,1,0,1.089L9.176,10.261a.77.77,0,0,1-1.314-.544V8.177H.738A.77.77,0,0,1-.032,7.407Zm11,5.018H4.111v-1.54A.77.77,0,0,0,2.8,10.341L.231,12.907A.77.77,0,0,0,.231,14L2.8,16.561a.77.77,0,0,0,1.314-.544v-1.54h6.862a.77.77,0,0,0,.77-.77v-.513A.77.77,0,0,0,10.973,12.425Z"
                  transform="translate(3.532 0.186)"
                  fill="#fff"
                />
              </svg>
            </span>
            <span class="menu-item-title">{{ "exchanges" | translate }}</span>
          </div>
        </li>

        <li
          nz-menu-item
          *ngIf="exchangeAccountList && exchangeAccountList?.length > 0"
          [routerLink]="['/', 'wise-trades']"
          [nzMatchRouter]="true"
          [nzMatchRouterExact]="true"
          class="single"
        >
          <div>
            <span class="icon-menu">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <g
                  id="Rectangle_2"
                  data-name="Rectangle 2"
                  fill="none"
                  stroke-width="1"
                >
                  <rect width="20" height="20" rx="4" stroke="none" />
                  <rect
                    x="0.5"
                    y="0.5"
                    width="19"
                    height="19"
                    rx="3.5"
                    fill="none"
                  />
                </g>
                <path
                  id="Icon_awesome-user-graduate"
                  data-name="Icon awesome-user-graduate"
                  d="M8.555,8.586,6,11.142,3.445,8.586A3.592,3.592,0,0,0,0,12.17v.257a1.286,1.286,0,0,0,1.286,1.286h9.429A1.286,1.286,0,0,0,12,12.427V12.17A3.592,3.592,0,0,0,8.555,8.586ZM.364,2.136l.171.04V3.741A.619.619,0,0,0,.512,4.812L.094,6.481c-.046.185.056.375.2.375h1.12c.147,0,.249-.19.2-.375L1.2,4.812a.619.619,0,0,0-.024-1.071V2.332l1.768.426A3.422,3.422,0,1,0,9.429,4.285a3.367,3.367,0,0,0-.375-1.527l2.579-.621a.426.426,0,0,0,0-.844L6.533.061a2.3,2.3,0,0,0-1.063,0L.364,1.29A.428.428,0,0,0,.364,2.136Z"
                  transform="translate(3.312 3.002)"
                  fill="#fff"
                />
              </svg>
            </span>
            <span class="menu-item-title">{{ "Wise Trade" | translate }}</span>
          </div>
        </li>

        <li
          *ngIf="exchangeAccountList && exchangeAccountList?.length > 0"
          nz-menu-item
          [routerLink]="['/', 'automated-trading']"
          [nzMatchRouter]="true"
          [nzMatchRouterExact]="true"
          class="single"
        >
          <div>
            <span class="icon-menu">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <g
                  id="Rectangle_2"
                  data-name="Rectangle 2"
                  fill="none"
                  stroke-width="1"
                >
                  <rect width="20" height="20" rx="4" stroke="none" />
                  <rect
                    x="0.5"
                    y="0.5"
                    width="19"
                    height="19"
                    rx="3.5"
                    fill="none"
                  />
                </g>
                <path
                  id="Icon_awesome-robot"
                  data-name="Icon awesome-robot"
                  d="M0,4.8V7.2a.6.6,0,0,0,.6.6h.6V4.2H.6A.6.6,0,0,0,0,4.8Zm8.7-3H6.6V.6A.6.6,0,0,0,5.4.6V1.8H3.3A1.5,1.5,0,0,0,1.8,3.3V8.4A1.2,1.2,0,0,0,3,9.6H9a1.2,1.2,0,0,0,1.2-1.2V3.3A1.5,1.5,0,0,0,8.7,1.8Zm-3.9,6H3.6V7.2H4.8ZM4.2,5.55a.75.75,0,1,1,.75-.75A.75.75,0,0,1,4.2,5.55ZM6.6,7.8H5.4V7.2H6.6Zm1.8,0H7.2V7.2H8.4ZM7.8,5.55a.75.75,0,1,1,.75-.75A.75.75,0,0,1,7.8,5.55ZM11.4,4.2h-.6V7.8h.6a.6.6,0,0,0,.6-.6V4.8A.6.6,0,0,0,11.4,4.2Z"
                  transform="translate(3.259 5.607)"
                  fill="#fff"
                />
              </svg>
            </span>
            <span class="menu-item-title">{{
              "Automated Trading" | translate
            }}</span>
          </div>
        </li>

        <!-- Sentiments -->
        <li
          nz-menu-item
          [routerLink]="['/', 'sentiments']"
          [nzMatchRouter]="true"
          [nzMatchRouterExact]="true"
          class="single"
        >
          <div>
            <span class="icon-menu">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <g
                  id="Group_404"
                  data-name="Group 404"
                  transform="translate(0.254)"
                >
                  <g
                    id="Rectangle_2"
                    data-name="Rectangle 2"
                    transform="translate(-0.254)"
                    fill="none"
                    stroke-width="1"
                  >
                    <rect width="20" height="20" rx="4" stroke="none" />
                    <rect
                      x="0.5"
                      y="0.5"
                      width="19"
                      height="19"
                      rx="3.5"
                      fill="none"
                    />
                  </g>
                  <g
                    id="Group_405"
                    data-name="Group 405"
                    transform="translate(4 4.75)"
                  >
                    <path
                      id="Icon_awesome-briefcase"
                      data-name="Icon awesome-briefcase"
                      d="M7.5,9.375a.375.375,0,0,1-.375.375H4.875A.375.375,0,0,1,4.5,9.375V8.25H0v3.375A1.153,1.153,0,0,0,1.125,12.75h9.75A1.153,1.153,0,0,0,12,11.625V8.25H7.5Z"
                      transform="translate(0 -2.25)"
                      fill="#fff"
                    />
                    <path
                      id="Icon_awesome-briefcase-2"
                      data-name="Icon awesome-briefcase"
                      d="M10.875,4.5H9V3.375A1.153,1.153,0,0,0,7.875,2.25H4.125A1.153,1.153,0,0,0,3,3.375V4.5H1.125A1.153,1.153,0,0,0,0,5.625V7.5H12V5.625A1.153,1.153,0,0,0,10.875,4.5ZM7.5,4.5h-3V3.75h3Z"
                      transform="translate(0 -2.25)"
                      fill="#fff"
                    />
                  </g>
                </g>
              </svg>
            </span>
            <span>{{ "sentiments.Market Sentiment" | translate }}</span>
          </div>
        </li>

        <!-- Crypto News -->
        <li
          nz-menu-item
          [routerLink]="['/', 'crypto-news']"
          [nzMatchRouter]="true"
          [nzMatchRouterExact]="true"
          class="single"
        >
          <!-- <li nz-menu-item [nzMatchRouter]="true" [nzMatchRouterExact]="true"
                    class="single" (click)="CryptoUrl()"> -->
          <div>
            <span class="icon-menu">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <g
                  id="Group_404"
                  data-name="Group 404"
                  transform="translate(0.254)"
                >
                  <g
                    id="Rectangle_2"
                    data-name="Rectangle 2"
                    transform="translate(-0.254)"
                    fill="none"
                    stroke-width="1"
                  >
                    <rect width="20" height="20" rx="4" stroke="none" />
                    <rect
                      x="0.5"
                      y="0.5"
                      width="19"
                      height="19"
                      rx="3.5"
                      fill="none"
                    />
                  </g>
                  <g
                    id="Group_405"
                    data-name="Group 405"
                    transform="translate(4 4.75)"
                  >
                    <path
                      id="Icon_awesome-briefcase"
                      data-name="Icon awesome-briefcase"
                      d="M7.5,9.375a.375.375,0,0,1-.375.375H4.875A.375.375,0,0,1,4.5,9.375V8.25H0v3.375A1.153,1.153,0,0,0,1.125,12.75h9.75A1.153,1.153,0,0,0,12,11.625V8.25H7.5Z"
                      transform="translate(0 -2.25)"
                      fill="#fff"
                    />
                    <path
                      id="Icon_awesome-briefcase-2"
                      data-name="Icon awesome-briefcase"
                      d="M10.875,4.5H9V3.375A1.153,1.153,0,0,0,7.875,2.25H4.125A1.153,1.153,0,0,0,3,3.375V4.5H1.125A1.153,1.153,0,0,0,0,5.625V7.5H12V5.625A1.153,1.153,0,0,0,10.875,4.5ZM7.5,4.5h-3V3.75h3Z"
                      transform="translate(0 -2.25)"
                      fill="#fff"
                    />
                  </g>
                </g>
              </svg>
            </span>
            <span class="menu-item-title">{{ "Crypto News" | translate }}</span>
          </div>
        </li>

        <li
          *ngIf="principal?.isAdmin()"
          nzIcon="scissor"
          nz-submenu
          nzTitle="Administration"
        >
          <ul>
            <li
              nz-menu-item
              [routerLink]="['/', 'admin', 'maintenance']"
              [nzMatchRouter]="true"
              [nzMatchRouterExact]="true"
            >
              <div>
                <span class="icon-menu">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <g id="Group_623" data-name="Group 623">
                      <g
                        id="Rectangle_2"
                        data-name="Rectangle 2"
                        fill="none"
                        stroke-width="1"
                      >
                        <rect width="20" height="20" rx="4" stroke="none" />
                        <rect
                          x="0.5"
                          y="0.5"
                          width="19"
                          height="19"
                          rx="3.5"
                          fill="none"
                        />
                      </g>
                    </g>
                    <path
                      id="Icon_awesome-toolbox"
                      data-name="Icon awesome-toolbox"
                      d="M11.219,6.327l-1.01-1.01A.714.714,0,0,0,9.7,5.107H8.571V3.321A1.071,1.071,0,0,0,7.5,2.25H3.929A1.071,1.071,0,0,0,2.857,3.321V5.107H1.724a.715.715,0,0,0-.505.209L.209,6.327A.714.714,0,0,0,0,6.832V8.679H2.857V8.321a.357.357,0,0,1,.357-.357h.714a.357.357,0,0,1,.357.357v.357H7.143V8.321A.357.357,0,0,1,7.5,7.964h.714a.357.357,0,0,1,.357.357v.357h2.857V6.831A.714.714,0,0,0,11.219,6.327ZM7.143,5.107H4.286V3.679H7.143ZM8.571,9.75a.357.357,0,0,1-.357.357H7.5a.357.357,0,0,1-.357-.357V9.393H4.286V9.75a.357.357,0,0,1-.357.357H3.214a.357.357,0,0,1-.357-.357V9.393H0v2.143a.714.714,0,0,0,.714.714h10a.714.714,0,0,0,.714-.714V9.393H8.571Z"
                      transform="translate(4 2.75)"
                      fill="#fff"
                    />
                  </svg>
                </span>
                <span>{{ "maintenance" | translate }}</span>
              </div>
            </li>
            <li
              nz-menu-item
              [routerLink]="['/', 'admin', 'strategies']"
              [nzMatchRouter]="true"
              [nzMatchRouterExact]="true"
            >
              <div>
                <span class="icon-menu">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <g id="Group_624" data-name="Group 624">
                      <path
                        id="Rectangle_2"
                        data-name="Rectangle 2"
                        d="M4,1A3,3,0,0,0,1,4V16a3,3,0,0,0,3,3H16a3,3,0,0,0,3-3V4a3,3,0,0,0-3-3H4M4,0H16a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z"
                      />
                    </g>
                    <path
                      id="Icon_metro-target"
                      data-name="Icon metro-target"
                      d="M14.571,7.178H13.388A4.887,4.887,0,0,0,9.321,3.111V1.928h-1.5V3.111A4.887,4.887,0,0,0,3.753,7.178H2.571v1.5H3.753a4.887,4.887,0,0,0,4.067,4.067v1.183h1.5V12.745a4.887,4.887,0,0,0,4.067-4.067h1.183v-1.5Zm-2.709,0H10.692A2.256,2.256,0,0,0,9.321,5.806V4.637a3.386,3.386,0,0,1,2.541,2.541Zm-3.291,1.5a.75.75,0,1,1,.75-.75A.75.75,0,0,1,8.571,8.678Zm-.75-4.041V5.806A2.256,2.256,0,0,0,6.449,7.178H5.28A3.386,3.386,0,0,1,7.821,4.637ZM5.28,8.678H6.449A2.256,2.256,0,0,0,7.821,10.05v1.169A3.386,3.386,0,0,1,5.28,8.678Zm4.041,2.541V10.05a2.256,2.256,0,0,0,1.372-1.372h1.169A3.386,3.386,0,0,1,9.321,11.219Z"
                      transform="translate(1.43 2.072)"
                      fill="#888"
                    />
                  </svg>
                </span>
                <span>{{ "strategies" | translate }}</span>
              </div>
            </li>
            <li
              nz-menu-item
              [routerLink]="['/', 'admin', 'strategies-algorithm']"
              [nzMatchRouter]="true"
              [nzMatchRouterExact]="true"
            >
              <div>
                <span class="icon-menu">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <g id="Group_624" data-name="Group 624">
                      <path
                        id="Rectangle_2"
                        data-name="Rectangle 2"
                        d="M4,1A3,3,0,0,0,1,4V16a3,3,0,0,0,3,3H16a3,3,0,0,0,3-3V4a3,3,0,0,0-3-3H4M4,0H16a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z"
                      />
                    </g>
                    <path
                      id="Icon_metro-target"
                      data-name="Icon metro-target"
                      d="M14.571,7.178H13.388A4.887,4.887,0,0,0,9.321,3.111V1.928h-1.5V3.111A4.887,4.887,0,0,0,3.753,7.178H2.571v1.5H3.753a4.887,4.887,0,0,0,4.067,4.067v1.183h1.5V12.745a4.887,4.887,0,0,0,4.067-4.067h1.183v-1.5Zm-2.709,0H10.692A2.256,2.256,0,0,0,9.321,5.806V4.637a3.386,3.386,0,0,1,2.541,2.541Zm-3.291,1.5a.75.75,0,1,1,.75-.75A.75.75,0,0,1,8.571,8.678Zm-.75-4.041V5.806A2.256,2.256,0,0,0,6.449,7.178H5.28A3.386,3.386,0,0,1,7.821,4.637ZM5.28,8.678H6.449A2.256,2.256,0,0,0,7.821,10.05v1.169A3.386,3.386,0,0,1,5.28,8.678Zm4.041,2.541V10.05a2.256,2.256,0,0,0,1.372-1.372h1.169A3.386,3.386,0,0,1,9.321,11.219Z"
                      transform="translate(1.43 2.072)"
                      fill="#888"
                    />
                  </svg>
                </span>
                <span>{{ "Strategies Algorithm" | translate }}</span>
              </div>
            </li>
            <!-- <li
              nz-menu-item
              [routerLink]="['/', 'admin', 'subscriptions']"
              [nzMatchRouter]="true"
              [nzMatchRouterExact]="true"
            >
              <div>
                <span class="icon-menu">
                  <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                >
                  <g id="Group_404">
                    <g
                      id="Rectangle_2_hh"
                      fill="none"
                      stroke="#fff"
                      stroke-width="1"
                    >
                      <rect width="20" height="20" rx="4" stroke="none" />
                      <rect
                        x="0.5"
                        y="0.5"
                        width="19"
                        height="19"
                        rx="3.5"
                        fill="none"
                      />
                    </g>
                    <g id="Group_405" transform="translate(4 3)">
                      <path
                        id="Icon_awesome-briefcase"
                        d="M 7.5 9.375 C 7.5 9.582187652587891 7.332187652587891 9.75 7.125 9.75 L 4.875 9.75 C 4.667812347412109 9.75 4.5 9.582187652587891 4.5 9.375 L 4.5 8.25 L 0 8.25 L 0 11.625 C 0 12.22500038146973 0.5250000357627869 12.75 1.125 12.75 L 10.875 12.75 C 11.47500038146973 12.75 12 12.22500038146973 12 11.625 L 12 8.25 L 7.5 8.25 L 7.5 9.375 Z"
                        fill="#fff"
                      />
                      <path
                        id="Icon_awesome-briefcase_hk"
                        d="M 10.875 4.5 L 9 4.5 L 9 3.375 C 9 2.775000095367432 8.475000381469727 2.25 7.875 2.25 L 4.125 2.25 C 3.525000095367432 2.25 3 2.775000095367432 3 3.375 L 3 4.5 L 1.125 4.5 C 0.5250000357627869 4.5 0 5.025000095367432 0 5.625 L 0 7.5 L 12 7.5 L 12 5.625 C 12 5.025000095367432 11.47500038146973 4.5 10.875 4.5 Z M 7.5 4.5 L 4.5 4.5 L 4.5 3.75 L 7.5 3.75 L 7.5 4.5 Z"
                        fill="#fff"
                      />
                    </g>
                  </g>
                </svg>
                </span>
                <span>{{ "Subscriptions" | translate }}</span>
              </div>
            </li> -->
            <li
              nz-menu-item
              [routerLink]="['/', 'admin', 'users']"
              [nzMatchRouter]="true"
              [nzMatchRouterExact]="true"
            >
              <div>
                <span class="icon-menu">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <g
                      id="Group_768"
                      data-name="Group 768"
                      transform="translate(-704 -765)"
                    >
                      <g
                        id="Group_625"
                        data-name="Group 625"
                        transform="translate(704 765)"
                      >
                        <g
                          id="Rectangle_2"
                          data-name="Rectangle 2"
                          fill="none"
                          stroke="#888"
                          stroke-width="1"
                        >
                          <rect width="20" height="20" rx="4" stroke="none" />
                          <rect
                            x="0.5"
                            y="0.5"
                            width="19"
                            height="19"
                            rx="3.5"
                            fill="none"
                          />
                        </g>
                      </g>
                      <g
                        id="Icon_feather-users"
                        data-name="Icon feather-users"
                        transform="translate(706.8 766)"
                      >
                        <path
                          id="Path_139"
                          data-name="Path 139"
                          d="M10.2,25.8a.6.6,0,0,1-.6-.6V24a1.8,1.8,0,0,0-1.8-1.8H3A1.8,1.8,0,0,0,1.2,24v1.2a.6.6,0,0,1-1.2,0V24a3,3,0,0,1,3-3H7.8a3,3,0,0,1,3,3v1.2A.6.6,0,0,1,10.2,25.8Z"
                          transform="translate(0 -10.8)"
                          fill="#888"
                        />
                        <path
                          id="Path_140"
                          data-name="Path 140"
                          d="M9,3A3,3,0,1,1,6,6,3,3,0,0,1,9,3ZM9,7.8A1.8,1.8,0,1,0,7.2,6,1.8,1.8,0,0,0,9,7.8Z"
                          transform="translate(-3.6)"
                          fill="#888"
                        />
                        <path
                          id="Path_141"
                          data-name="Path 141"
                          d="M30.9,25.917a.6.6,0,0,1-.6-.6v-1.2a1.8,1.8,0,0,0-1.35-1.741.6.6,0,1,1,.3-1.162,3,3,0,0,1,2.25,2.9v1.2A.6.6,0,0,1,30.9,25.917Z"
                          transform="translate(-17.1 -10.917)"
                          fill="#888"
                        />
                        <path
                          id="Path_142"
                          data-name="Path 142"
                          d="M23.1,9.045a.6.6,0,0,1-.148-1.181,1.8,1.8,0,0,0,0-3.487.6.6,0,1,1,.3-1.162,3,3,0,0,1,0,5.813A.6.6,0,0,1,23.1,9.045Z"
                          transform="translate(-13.5 -0.117)"
                          fill="#888"
                        />
                      </g>
                    </g>
                  </svg>
                </span>
                <span>{{ "users" | translate }}</span>
              </div>
            </li>
            <li
              nz-menu-item
              [routerLink]="['/', 'admin', 'customer-support']"
              [nzMatchRouter]="true"
              [nzMatchRouterExact]="true"
            >
              <div>
                <span class="icon-menu">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="510"
                    height="325.581"
                    viewBox="0 0 510 325.581"
                  >
                    <path
                      id="support-ticket_1"
                      d="M496.616,258.148H503a8,8,0,0,0,8-8V167.777a22.039,22.039,0,0,0-22.014-22.014h-39.3v-30.54a22.039,22.039,0,0,0-22.014-22.014H23.014A22.041,22.041,0,0,0,1,115.224V197.6a8,8,0,0,0,8,8h6.383a24.129,24.129,0,0,1,0,48.257H9a8,8,0,0,0-8,8v82.371a22.038,22.038,0,0,0,22.014,22.014h39.3v30.539A22.038,22.038,0,0,0,84.326,418.79H488.985A22.038,22.038,0,0,0,511,396.776V314.4a8,8,0,0,0-8-8h-6.383a24.128,24.128,0,0,1,0-48.257ZM17,344.223v-74.4a40.129,40.129,0,0,0,0-80.193v-74.4a6.021,6.021,0,0,1,6.014-6.014h99.243v12.61a8,8,0,1,0,16,0V109.21H427.674a6.021,6.021,0,0,1,6.014,6.014v74.4a40.129,40.129,0,0,0,0,80.193v74.4a6.021,6.021,0,0,1-6.014,6.014H317.088V317.023c24.145-11.788,41.168-38.342,41.168-65.228,0-26.07-12.248-47.954-34.487-61.621a8,8,0,0,0-12.189,6.815V245.8l-25.608,14.785L260.364,245.8V196.99a8,8,0,0,0-12.189-6.815c-22.239,13.667-34.486,35.551-34.486,61.621,0,26.885,17.026,53.44,41.168,65.228v33.214h-116.6v-12.61a8,8,0,0,0-16,0v12.61H23.014A6.022,6.022,0,0,1,17,344.223Zm248.735-39.894c-20.886-8.052-36.045-30.145-36.045-52.534,0-17.507,6.614-29.772,14.675-38.217v36.839a8,8,0,0,0,4,6.928l33.608,19.4a8,8,0,0,0,8,0l33.608-19.4a8,8,0,0,0,4-6.928V213.578c8.061,8.445,14.675,20.71,14.675,38.217,0,22.388-15.159,44.481-36.046,52.534a8,8,0,0,0-5.122,7.464v38.444h-30.23V311.793a8,8,0,0,0-5.123-7.464ZM495,322.373v74.4a6.021,6.021,0,0,1-6.014,6.014H84.326a6.021,6.021,0,0,1-6.014-6.014V366.237H427.673a22.039,22.039,0,0,0,22.014-22.014V261.852a8,8,0,0,0-8-8H435.3a24.129,24.129,0,0,1,0-48.257h6.383a8,8,0,0,0,8-8V161.764h39.3A6.021,6.021,0,0,1,495,167.778v74.4a40.129,40.129,0,0,0,0,80.192ZM89,155.008H50.254a8,8,0,0,1,0-16H89a8,8,0,0,1,0,16Zm102.116,24.373H380.826a8,8,0,0,0,8-8V132.87a8,8,0,0,0-8-8H191.119a8,8,0,0,0-8,8v38.512A8,8,0,0,0,191.119,179.381Zm8-38.511H372.826v22.512H199.119ZM89,312.571H50.254a8,8,0,0,1,0-16H89a8,8,0,0,1,0,16ZM42.254,274.737a8,8,0,0,1,8-8H89a8,8,0,0,1,0,16H50.254A8,8,0,0,1,42.254,274.737Zm80-105.633v-20.61a8,8,0,0,1,16,0V169.1a8,8,0,0,1-16,0Zm0,47.283v-20.61a8,8,0,0,1,16,0v20.61a8,8,0,0,1-16,0Zm0,47.283V243.06a8,8,0,0,1,16,0v20.61a8,8,0,0,1-16,0Zm0,47.284v-20.61a8,8,0,0,1,16,0v20.61a8,8,0,0,1-16,0Z"
                      transform="translate(-1 -93.209)"
                      fill="aqua"
                    />
                  </svg>
                </span>
                <span>{{ "Customer Support" | translate }}</span>
              </div>
            </li>
          </ul>
        </li>

        <!-- Market Place -->
        <li
          nz-menu-item
          [routerLink]="['/', 'market-place']"
          [nzMatchRouter]="true"
          [nzMatchRouterExact]="true"
          class="single"
        >
          <div>
            <span class="icon-menu">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <g
                  id="Group_404"
                  data-name="Group 404"
                  transform="translate(0.254)"
                >
                  <g
                    id="Rectangle_2"
                    data-name="Rectangle 2"
                    transform="translate(-0.254)"
                    fill="none"
                    stroke-width="1"
                  >
                    <rect width="20" height="20" rx="4" stroke="none" />
                    <rect
                      x="0.5"
                      y="0.5"
                      width="19"
                      height="19"
                      rx="3.5"
                      fill="none"
                    />
                  </g>
                  <g
                    id="Group_405"
                    data-name="Group 405"
                    transform="translate(4 4.75)"
                  >
                    <path
                      id="Icon_awesome-briefcase"
                      data-name="Icon awesome-briefcase"
                      d="M7.5,9.375a.375.375,0,0,1-.375.375H4.875A.375.375,0,0,1,4.5,9.375V8.25H0v3.375A1.153,1.153,0,0,0,1.125,12.75h9.75A1.153,1.153,0,0,0,12,11.625V8.25H7.5Z"
                      transform="translate(0 -2.25)"
                      fill="#fff"
                    />
                    <path
                      id="Icon_awesome-briefcase-2"
                      data-name="Icon awesome-briefcase"
                      d="M10.875,4.5H9V3.375A1.153,1.153,0,0,0,7.875,2.25H4.125A1.153,1.153,0,0,0,3,3.375V4.5H1.125A1.153,1.153,0,0,0,0,5.625V7.5H12V5.625A1.153,1.153,0,0,0,10.875,4.5ZM7.5,4.5h-3V3.75h3Z"
                      transform="translate(0 -2.25)"
                      fill="#fff"
                    />
                  </g>
                </g>
              </svg>
            </span>
            <span class="menu-item-title">{{
              "Market Place" | translate
            }}</span>
          </div>
        </li>
        <!-- Customer Support -->
        <li
          nz-menu-item
          [routerLink]="['/', 'customer-support']"
          [nzMatchRouter]="true"
          [nzMatchRouterExact]="true"
          class="single"
        >
          <div>
            <span class="icon-menu">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="510"
                height="325.581"
                viewBox="0 0 510 325.581"
              >
                <path
                  id="support-ticket_1"
                  d="M496.616,258.148H503a8,8,0,0,0,8-8V167.777a22.039,22.039,0,0,0-22.014-22.014h-39.3v-30.54a22.039,22.039,0,0,0-22.014-22.014H23.014A22.041,22.041,0,0,0,1,115.224V197.6a8,8,0,0,0,8,8h6.383a24.129,24.129,0,0,1,0,48.257H9a8,8,0,0,0-8,8v82.371a22.038,22.038,0,0,0,22.014,22.014h39.3v30.539A22.038,22.038,0,0,0,84.326,418.79H488.985A22.038,22.038,0,0,0,511,396.776V314.4a8,8,0,0,0-8-8h-6.383a24.128,24.128,0,0,1,0-48.257ZM17,344.223v-74.4a40.129,40.129,0,0,0,0-80.193v-74.4a6.021,6.021,0,0,1,6.014-6.014h99.243v12.61a8,8,0,1,0,16,0V109.21H427.674a6.021,6.021,0,0,1,6.014,6.014v74.4a40.129,40.129,0,0,0,0,80.193v74.4a6.021,6.021,0,0,1-6.014,6.014H317.088V317.023c24.145-11.788,41.168-38.342,41.168-65.228,0-26.07-12.248-47.954-34.487-61.621a8,8,0,0,0-12.189,6.815V245.8l-25.608,14.785L260.364,245.8V196.99a8,8,0,0,0-12.189-6.815c-22.239,13.667-34.486,35.551-34.486,61.621,0,26.885,17.026,53.44,41.168,65.228v33.214h-116.6v-12.61a8,8,0,0,0-16,0v12.61H23.014A6.022,6.022,0,0,1,17,344.223Zm248.735-39.894c-20.886-8.052-36.045-30.145-36.045-52.534,0-17.507,6.614-29.772,14.675-38.217v36.839a8,8,0,0,0,4,6.928l33.608,19.4a8,8,0,0,0,8,0l33.608-19.4a8,8,0,0,0,4-6.928V213.578c8.061,8.445,14.675,20.71,14.675,38.217,0,22.388-15.159,44.481-36.046,52.534a8,8,0,0,0-5.122,7.464v38.444h-30.23V311.793a8,8,0,0,0-5.123-7.464ZM495,322.373v74.4a6.021,6.021,0,0,1-6.014,6.014H84.326a6.021,6.021,0,0,1-6.014-6.014V366.237H427.673a22.039,22.039,0,0,0,22.014-22.014V261.852a8,8,0,0,0-8-8H435.3a24.129,24.129,0,0,1,0-48.257h6.383a8,8,0,0,0,8-8V161.764h39.3A6.021,6.021,0,0,1,495,167.778v74.4a40.129,40.129,0,0,0,0,80.192ZM89,155.008H50.254a8,8,0,0,1,0-16H89a8,8,0,0,1,0,16Zm102.116,24.373H380.826a8,8,0,0,0,8-8V132.87a8,8,0,0,0-8-8H191.119a8,8,0,0,0-8,8v38.512A8,8,0,0,0,191.119,179.381Zm8-38.511H372.826v22.512H199.119ZM89,312.571H50.254a8,8,0,0,1,0-16H89a8,8,0,0,1,0,16ZM42.254,274.737a8,8,0,0,1,8-8H89a8,8,0,0,1,0,16H50.254A8,8,0,0,1,42.254,274.737Zm80-105.633v-20.61a8,8,0,0,1,16,0V169.1a8,8,0,0,1-16,0Zm0,47.283v-20.61a8,8,0,0,1,16,0v20.61a8,8,0,0,1-16,0Zm0,47.283V243.06a8,8,0,0,1,16,0v20.61a8,8,0,0,1-16,0Zm0,47.284v-20.61a8,8,0,0,1,16,0v20.61a8,8,0,0,1-16,0Z"
                  transform="translate(-1 -93.209)"
                  fill="aqua"
                />
              </svg>
            </span>
            <span class="menu-item-title">{{
              "Customer Support" | translate
            }}</span>
          </div>
        </li>
      </ul>
    </div>
  </nz-sider>
  <nz-layout class="inner-layout">
    <nz-back-top></nz-back-top>
    <nz-header>
      <div nz-row class="ant-row-end menuControl">
        <div
          nz-col
          nzXs="14"
          nzSm="8"
          nzMd="6"
          nzLg="6"
          [nzXl]="4"
          nzXXl="3"
          class="m-r-auto align-self-end ant-col-order-2 order-1 order-xs-3"
        >
          <div class="show-navigation">
            <h1>{{ routeState }}</h1>
          </div>
        </div>
      </div>
    </nz-header>
    <nz-alert
      *ngFor="let adminMessage of adminMessages"
      nzType="info"
      nzMessage="{{ adminMessage.message }}"
      nzCloseText="Close Now"
    ></nz-alert>
    <nz-content>
      <router-outlet></router-outlet>
    </nz-content>
  </nz-layout>
</nz-layout>
<ng-template #logoutConfirmTpl>
  <h3>{{ "logout" | translate }}</h3>
  <p style="max-width: 300px">{{ "logout-msg" | translate }}</p>
</ng-template>

<ng-template #modalFooter>
  <span>Modal Footer:</span>
  <button
    nz-button
    nzType="primary"
    style="width: 5vw"
    (click)="navigateToSettings()"
  >
    OK
  </button>
  <button nz-button nzType="default" style="width: 5vw">Cancel</button>
</ng-template>

<ng-template #2fContent>
  <p style="text-align: center">
    For additional security we suggest setting up Google Authenticator from the
    Settings tab.
  </p>
  <p style="text-align: center">
    Click 'OK' to Enable 2 factor authentication, Cancel To Ignore
  </p>
</ng-template>
